import { Card, Text, Progress, Group, Stack } from "@mantine/core";
import type { AdoptionRateMetrics } from "../types";

interface AdoptionRateCardProps {
  adoptionRate: AdoptionRateMetrics;
}

const getProgressColor = (percentage: number): string => {
  if (percentage >= 50) return "green";
  if (percentage >= 25) return "yellow";
  return "red";
};

export const AdoptionRateCard = ({ adoptionRate }: AdoptionRateCardProps) => {
  const { totalBusinessStaff, businessStaffWithReturns, adoptionPercentage } =
    adoptionRate;

  return (
    <Card shadow="sm" padding="lg" radius="md" withBorder>
      <Stack gap="md">
        <Text fw={700} size="xl">
          OneClick Adoption Rate
        </Text>

        <Text size="lg" c="dimmed">
          {businessStaffWithReturns.toLocaleString()} out of{" "}
          {totalBusinessStaff.toLocaleString()} business staff have tried
          OneClick
        </Text>

        <Progress
          value={adoptionPercentage}
          size="xl"
          radius="md"
          color={getProgressColor(adoptionPercentage)}
        />

        <Group justify="center">
          <Text fw={700} size="2rem">
            {adoptionPercentage.toFixed(1)}%
          </Text>
        </Group>
      </Stack>
    </Card>
  );
};
